// Mapbox binds resize, orientationchange and the fullscreen event to _onWindowResize, which forwards
// them as originalEvent — those are the container moving the map, not the user.
const CONTAINER_DRIVEN_TYPES = [
  'resize',
  'orientationchange',
  'fullscreenchange',
  'webkitfullscreenchange',
]

export const isUserDrivenMove = ({
  originalEvent,
}: {
  originalEvent?: Event
}): boolean =>
  !!originalEvent && !CONTAINER_DRIVEN_TYPES.includes(originalEvent.type)
